import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../../base/BaseComponent';

export default class OptionRange extends BaseComponent {
    static defaultProps = {
        checked: false,
        channel: '途径不限',
        onClickCall: () => {
            console.log("点击");
        },
        file: {}
    };
    static propTypes = {
        // channel: PropTypes.string.isRequired,//途径范围
        // onClick: PropTypes.func.isRequired,//点击函数
        // IsChecked: PropTypes.func.isRequired,//选中的函数
    };

    constructor(props) {
        super(props);
        this.state = {
            menuValue: "",
            nameOrCode:'', //搜索的字段
            page:1,
            size:1000,
            count:0,

        }
    };


    allCheckData = [];
    selectMenu(data) {
        data&&data.forEach((item)=>{
            this.allCheckData.push(item);
        })
        this.setState({});
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall(data, this.allCheckData)
        }
    };

    render() {

        return (
            <div>
                {this.props.configs && this.props.configs.length ? (
                    this.props.configs.map((config,index)=>{
                        let Elem=null;
                        if(typeof config === 'string') {
                            Elem = require(`./component/${config}`); // 引入编辑器
                        }
                        return  Elem?
                            <Elem.default key={index} configName={this.props.configName} purpose={this.props.purpose} onClickCall={(data)=>this.selectMenu(data)}/>
                            :null
                    })
                ) : null }

            </div>
        );
    };

}
